import React, { useContext } from "react";
import { Card, EmptyState, Page, Text } from "@shopify/polaris";
import { AppContext } from "../../../../../components/global/appContext";
import { useTranslation } from "react-i18next";
export default function ThemeLanguageEmptyState() {
  const { enabledFeatures } = useContext(AppContext);
  const { t } = useTranslation();
  
  return (
    <Page>
      <Card sectioned>
        <EmptyState
          heading={t("themes.emptyStates.language.heading")}
          image="https://cdn.shopify.com/s/files/1/2376/3301/products/emptystate-files.png"
          action={
            enabledFeatures?.includes("custom_themes")
              ? {
                  content: t("themes.emptyStates.language.createLanguageTerms"),
                  url: `/themes/live/language`,
                }
              : { content: t("themes.emptyStates.language.upgradePlan"), url: "/plan" }
          }
        >
          <p>
            <Text variant="bodyMd" as="span">{t("themes.emptyStates.language.description")}</Text>
          </p>
          {enabledFeatures?.includes("custom_themes") || (
            <p>
              <Text  variant="bodyMd" as="span" color="critical">{t("themes.emptyStates.language.upgradeRequired")}</Text>
            </p>
          )}
        </EmptyState>
      </Card>
    </Page>
  );
}
